import EventBus from '@/eventBus';
import bus from '@/eventBus/bus.js';

export default {
  mixins: [bus],
  created() {
    this.busListener();
  },
  data() {
    return {
      indonesianVoice: null,
      audioQueue: [],
      isPlaying: false,
      lastPlayedSound: null,
      currentAudio: null,
    };
  },
  watch: {
    isPlaying(val) {
      // If not currently playing anything, start the queue
      const len = this.audioQueue.length;
      if (!val && len > 0) {
        this.processQueue();
      }
    },
  },
  mounted() {
    this.initializeVoices();
    this.triggerEmptySpeech();
  },
  methods: {
    initializeVoices() {
      const loadVoices = () => {
        const voices = window.speechSynthesis.getVoices();
        this.indonesianVoice =
          voices.find(voice => voice.lang === 'id-ID') || voices[0];
      };

      if (window.speechSynthesis.getVoices().length === 0) {
        window.speechSynthesis.onvoiceschanged = loadVoices;
      } else {
        loadVoices();
      }
    },
    triggerEmptySpeech() {
      const speech = new SpeechSynthesisUtterance('');
      speech.rate = 1;
      speech.lang = 'id-ID';
      speech.voice = this.indonesianVoice;

      window.speechSynthesis.speak(speech);
    },
    emitMessageCall(payload) {
      this.$socket.client.emit('message:call', payload);
      // EventBus.$emit('message:call', payload);
    },
    async onMessageUpdate({ refresh, isCalling }) {
      this.$socket.client.off('message:update');
      this.$socket.client.on('message:update', async data => {
        await refresh(); // refresh data on page

        // data.is_not_call will be true when coming from registration,
        // to disable sound playback after registration
        if (isCalling && data.queue_code && !data.is_not_call)
          this.callPatient({
            ...data,
            patient_name: data.patient_name.toLowerCase(),
          });
      });
    },
    emitIsCalling(data) {
      EventBus.callPatient$emit('message:call', data);
    },
    async checkSound() {
      this.$socket.client.on('message:check-sound-call', () => {
        const audio = this.$refs.notification;
        if (audio.paused) {
          this.$socket.client.emit('message:check-sound-on');
          audio.play();
          this.$socket.client.emit('message:check-sound-end');
        } else {
          audio.pause();
          audio.currentTime = 0;
        }
      });
    },
    callPatient(data) {
      if (data.sound_url) {
        this.playSound(data.sound_url);
        return;
      }
      const methods = this;
      const text = [];
      const statusCall = status => {
        const trimmedStatus = status.trim().toUpperCase();
        const statusMapping = {
          'TN.': 'Tuan',
          'NN.': 'Nona',
          'NY.': 'Nyonya',
          'BY.': 'Bayi',
          'AN.': 'Anak',
          'SDR.': 'Saudara',
        };
        return statusMapping[trimmedStatus] || '';
      };

      // methods.speak('Nomor antrean', 1);
      text.push('Nomor antrean');

      const alphanumeric = data.queue_code
        .toLowerCase()
        .replace(/[^a-zA-Z0-9]/g, '')
        .split('');
      for (let i = 0; i < alphanumeric.length; i++) {
        text.push(alphanumeric[i]);
      }

      text.push(
        `${statusCall(
          data.patient_name.split(' ')[data.patient_name.split(' ').length - 1],
        )} ${data.patient_name.split(' ').slice(0, -1)}`,
      );

      text.push(`Silahkan ke ruangan ${data.room}`);
      methods.speak(text, 1.1);
    },
    speak(words, rate) {
      const wordsText = !Array.isArray(words) ? [words] : words;

      window.speechSynthesis.cancel();

      const speakNext = index => {
        if (index >= wordsText.length) return;

        const speech = new SpeechSynthesisUtterance(wordsText[index]);
        speech.rate = rate;
        speech.lang = 'id-ID';
        speech.voice = this.indonesianVoice;

        window.speechSynthesis.speak(speech);
        speech.onend = () => speakNext(index + 1);
      };

      speakNext(0);
    },
    playSound(soundUrl) {
      // If this is the same sound as the last one played/queued, ignore it
      // if (this.lastPlayedSound === soundUrl) {
      //   console.log('Duplicate sound detected, ignoring:', soundUrl);
      //   return;
      // }

      // Add sound to queue and update last played sound
      this.audioQueue.push(soundUrl);

      // If not currently playing anything, start the queue
      if (!this.isPlaying) {
        this.processQueue();
      }
    },

    processQueue() {
      // If queue is empty or already playing, exit
      if (this.isPlaying) {
        return;
      }
      if (this.audioQueue.length === 0) {
        this.lastPlayedSound = null;
        this.currentAudio = null;
        return;
      }

      // Set playing flag
      this.isPlaying = true;

      // Get the next sound from queue
      const soundUrl = this.audioQueue.shift();

      // Create and play audio
      this.currentAudio = new Audio(soundUrl);
      this.lastPlayedSound = soundUrl;
      // When audio ends, process next in queue
      this.currentAudio.onended = () => {
        this.isPlaying = false;
        this.processQueue();
      };

      // Handle errors
      this.currentAudio.onerror = () => {
        // console.error('Audio playback error:', error);
        this.isPlaying = false;
        this.processQueue();
      };

      // Play the audio
      this.currentAudio.play().catch(() => {
        // console.error('Failed to play audio:', error);
        this.isPlaying = false;
        this.processQueue();
      });
    },

    // Optional: method to clear the queue if needed
    clearQueue() {
      this.audioQueue = [];
      if (this.currentAudio) {
        this.currentAudio.pause();
        this.currentAudio = null;
      }
      this.isPlaying = false;
      this.lastPlayedSound = null;
    },
  },
};
